module.exports = __webpack_public_path__ + "img/about-section-2.c6dce434.jpg";